// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"7cf16a84","148":"0f466e41","410":"65b0ad22","656":"c48f96c3","832":"d059661d","882":"7176e799"}[chunkId] + ".chunk.js";
};